import { forwardRef, useImperativeHandle, useState } from "react"
import { Modal, Box, TextField, Button, Typography } from "@mui/material"
import ModalCloseButton from "../../Modals/ModalCloseButton"
import { useApiService } from "../../hooks/Api/useApiService"
import T from "../../hooks/Language/T"

import useTranslationSharie from "../../hooks/Language/useTranslation"
const AddTestamonyModal = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    childFunction() {
      handleOpen()
    },
  }))
  const [open, setOpen] = useState(false)
  const [userName, setUserName] = useState(localStorage.getItem("user"))
  const [message, setMessage] = useState("")
  const { postData } = useApiService()
  const t = useTranslationSharie()

  const handleSubmit = async (e) => {
    e.preventDefault()

    postData("sharie/addtestamony", { user_name: userName, message })
      .then(() => {
        handleClose()
      })
      .catch((error) => {
        console.error("Error submitting testamony:", error)
      })
  }
  const handleOpen = () => setOpen(true)
  const handleClose = () => setOpen(false)

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby='modal-title'
      aria-describedby='modal-description'
    >
      <T>
        <ModalCloseButton handleClose={handleClose} />
        <Box
          sx={{
            backgroundColor: "background.paper",
            padding: 4,
            borderRadius: 3,
            width: "90%",
            maxWidth: 500,
            margin: "10% auto",
            boxShadow: 24,
          }}
        >
          <Typography
            id='modal-title'
            variant='h5'
            color='primary'
            fontWeight='bold'
            gutterBottom
            textAlign='center'
          >
            {t("Share Your Experience")}
          </Typography>

          <Typography
            id='modal-description'
            variant='body2'
            color='textSecondary'
            textAlign='center'
            mb={3}
          >
            {t("We'd love to hear what you think about Sharie!")}
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label={t("Your Message")}
              variant='outlined'
              multiline
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              margin='normal'
              required
              color='primary'
            />

            <Button
              type='submit'
              variant='contained'
              color='primary'
              fullWidth
              sx={{
                mt: 3,
                borderRadius: 2,
                py: 1.2,
                fontWeight: "bold",
                textTransform: "none",
              }}
              disabled={localStorage.getItem("guest") === "true"}
            >
              {t("Submit Testamony")}
            </Button>
          </form>
        </Box>
      </T>
    </Modal>
  )
})

export default AddTestamonyModal
